module.exports = __webpack_public_path__ + "img/E_illustration.ab5a149c.gif";